import * as React from 'react';

function SvgAxLogo(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 122 14" {...props}>
      <path
        fill="#434343"
        d="M23.6 0c2.208 0 3.81.898 5.032 2.306l-.864.624c-.937-1.135-2.466-1.883-4.167-1.883-3.145 0-5.574 2.406-5.574 5.934 0 3.491 2.43 5.96 5.574 5.96 1.788 0 3.193-.898 3.933-1.646V8.09h-5.536l.456-1.06h6.215v4.725A6.77 6.77 0 0 1 23.6 14c-3.773 0-6.782-2.842-6.782-7.019C16.819 2.817 19.828 0 23.6 0M51.961 2.069v11.669h-1.146V.224h1.159l8.384 11.506V.224h1.147v13.514h-1.122zM68.053 6.994C68.053 2.842 71.037 0 74.785 0c2.17 0 3.773.947 4.908 2.394l-.962.623c-.838-1.172-2.306-1.97-3.946-1.97-3.107 0-5.536 2.406-5.536 5.934 0 3.49 2.429 5.934 5.536 5.934 1.64 0 3.108-.785 3.946-1.97l.962.611c-1.184 1.484-2.75 2.407-4.908 2.407-3.748.025-6.732-2.818-6.732-6.97M89.42 7.966 84.107.224h1.382L90 6.869 94.513.224h1.381L90.58 7.966v5.772h-1.16zM6.893.224H5.475L0 13.738h1.282l4.896-12.38 3.206 8.004h-3.97l-.432 1.06h4.76l1.343 3.316h1.283zM44.18.224h-8.927v1.06h8.928zM41.887 6.06h-6.634v1.047h6.178zM44.18 12.691h-8.927v1.06h8.928z"
      />
      <path fill="#CE9200" d="m113.923 7.604-4.797 6.158h1.443l4.056-5.323z" />
      <path
        fill="#434343"
        d="m115.957 6.794 5.081-6.57h-1.443l-4.353 5.734-4.328-5.734h-1.467l10.468 13.514h1.418z"
      />
    </svg>
  );
}
export default SvgAxLogo;
